import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { T } from '../../../components/Translations';
import { ApiUrl } from '../../../project/Defines.js';
import { EVENT_NAME } from '../../../project/utilities.js';
import ListView from '../../../Shared/ListView';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { PopupTypes } from '../../../components/Popup';
import { openPopup } from '../../../store/actions';




/**
 * the societe List
 * @exports EquipmentCardPicker
 */
function EquipmentCardPicker(props) {
    const listUpdateEvent = EVENT_NAME.SERVICE_CONTRACT_LIST_UPDATE;
    const { internal_serial_number, onClose, setDataItem } = props;
    const [detailProps] = useState({
        windowKey: 'wndEquipmentCardCreateForContract',
        popupType: PopupTypes.EquipmentCardEditForContract,
        fullScreen: false,
        listUpdateEvent,
        internal_serial_number
    });

    const onLoaded = (data) => {
        return data.map(card => {
            const index = card.OwnerName.indexOf('|');
            card.OwnerCode = card.OwnerName.slice(0, index);
            if (index !== -1) {
                card.OwnerName = card.OwnerName.slice(index + 1);
            }
            return card;
        });
    };
    const onSelect = (record) => {
        setDataItem(item => ({ ...item, product_code: record.CodeCom, item_code: record.ItemCode, internal_serial_number: record.InternalSN, customer_code: record.OwnerCode }));
        onClose();
    };
    const columnConfig = [
        {
            text: 'text.serial_number',
            field: 'InternalSN',
            type: COLUMN_TYPE.TEXT,
            noSort: true
        },
        {
            text: 'text.product',
            field: 'CodeCom',
            type: COLUMN_TYPE.TEXT,
            noSort: true,
            render: (t, record) => {
                const text = [
                    record.CodeCom,
                    record.ItemName
                ].filter(x => !!x).join(' - ');
                return <wrap title={text} >
                    <text>{text}</text>
                </wrap>;
            }
        },
        {
            text: 'text.customer_name',
            field: 'OwnerName',
            type: COLUMN_TYPE.TEXT,
            noSort: true
        },
        {
            text: 'text.address',
            field: 'Street',
            type: COLUMN_TYPE.TEXT,
            noSort: true,
            render: (t, record) => {
                const text = [
                    record.Street,
                    record.City,
                    record.Zip,
                    record.Country
                ].filter(x => !!x).join(', ');
                return <wrap title={text} >
                    <text>{text}</text>
                </wrap>;
            }
        },
        {
            type: COLUMN_TYPE.CUSTOM,
            width: 100,

            render: (text, record) => <elastic>
                <action hover="">
                    <div effect="material" className="button accent"
                        onClick={() => onSelect(record)}
                    >
                        <text><T>text.select</T></text>
                    </div>
                </action>
            </elastic>
        },
        {
            type: COLUMN_TYPE.ACTION
        }
    ];

    return (
        <ListView
            {...props}
            isSimple
            columnConfig={columnConfig}
            apiUrl={ApiUrl.EquipmentCardListForContract}
            staticFilter={{ internal_serial_number }}
            keyField='InsId'
            // onNewClick={openEquipmentCardCreate}
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            onLoaded={onLoaded}
        />
    );
}

EquipmentCardPicker.propTypes = {
    internal_serial_number: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    setDataItem: PropTypes.func.isRequired,
    openPopup: PropTypes.func.isRequired
};

export default connect(null, dispatch => ({ openPopup: (props) => dispatch(openPopup(props)) }))(EquipmentCardPicker);